<template>
  <v-card class="rounded-lg">
    <v-toolbar
        class="removeBtnPaddingRight pl-2"
        color="#DADADA"
        dense
        flat
    >
      <slot name="btn"></slot>
    </v-toolbar>
    <v-card-title>
      <v-row no-gutters class="text-left py-1">
        <v-col>
          Наименование поста охраны: {{ item.name }}
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row no-gutters class="text-left subtitle-1 py-1">
        <v-col cols="3" md="3" class="font-weight-bold">Пароль:</v-col>
        <v-col cols="9" md="3" class="text-right text-md-left">{{ item.password }}</v-col>
        <v-col cols="3" md="3" class="font-weight-bold">Пользователь AD:</v-col>
        <v-col cols="9" md="3" class="text-right text-md-left">{{ item.user_ad }}</v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-1">
        <v-col cols="3" class="font-weight-bold">Территория:</v-col>
        <v-col cols="9" class="text-right text-md-left">{{ item.territory.name }}</v-col>
      </v-row>
    </v-card-text>
    <slot name="detailBuildingList"></slot>
  </v-card>
</template>

<script>

export default {
  name: "GuardPostDetail",
  props:["item"],
  components: {},
  data() {
    return {
      headers: [
        {text: "ФИО", value: "building", sortable: false, align: "start", width: "100%"}
      ]
    }
  },
  computed: {},
  methods: {}
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
